import * as React from "react";
import { MediaQuery } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
import { TealiumButton } from "@grandvisionhq/svc-tealium/components";
import { getButtonColor, getButtonVariant } from "./helpers.js";
import SiteNavItem from "../SiteNavItem/SiteNav/SiteNavItem/SiteNavItem.js";
import SiteNavMobile from "../SiteNavMobile/SiteNav/SiteNavMobile/SiteNavMobile.js";
/* empty css             */
const SiteNav = ({
  menuItems,
  appointmentItems,
  routes,
  countrySwitcherOptions,
  renderCartButton,
  renderWishlistMenuItem,
  ordersUrl
}) => {
  const { getLabel } = useIntl();
  const navLabel = getLabel("common.screenreader.siteNavigationDesktop", {
    hideLabelKey: true
  });
  const breakpoint = MediaQuery.useBreakpoint();
  const isMobile = breakpoint === MediaQuery.BreakpointName.PHONE || breakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT;
  const [activeSubMenu, setActiveSubMenu] = React.useState("");
  const onBlur = React.useCallback(
    (e) => {
      const currentTarget = e.currentTarget;
      requestAnimationFrame(() => {
        if (!currentTarget.contains(document.activeElement)) setActiveSubMenu("");
      });
    },
    [setActiveSubMenu]
  );
  const focusCallback = (label) => () => {
    if (activeSubMenu !== label) setActiveSubMenu("");
  };
  if (isMobile) {
    return /* @__PURE__ */ React.createElement(
      SiteNavMobile,
      {
        routes,
        ctaItems: appointmentItems,
        menuItems,
        countrySwitcherOptions,
        renderCartButton,
        renderWishlistMenuItem,
        ordersUrl
      }
    );
  }
  return /* @__PURE__ */ React.createElement("nav", { className: "site-nav", "data-t": "site-nav", ...navLabel && { "aria-label": navLabel } }, /* @__PURE__ */ React.createElement("div", { className: "site-container site-nav__container" }, /* @__PURE__ */ React.createElement("ul", { className: "site-nav__menu", onBlur }, menuItems.map((item) => /* @__PURE__ */ React.createElement(
    SiteNavItem,
    {
      key: item.label,
      ...item,
      focusCallback: focusCallback(item.label),
      activeSubMenu,
      setActiveSubMenu
    }
  ))), appointmentItems && /* @__PURE__ */ React.createElement("div", { className: "site-nav__appointment", "data-t": "site-nav-appointment" }, appointmentItems.map((item) => /* @__PURE__ */ React.createElement(
    TealiumButton,
    {
      key: item.label,
      icon: item.parameters?.icon,
      className: item.parameters?.icon && "site-nav__appointment-btn",
      href: item.link && item.link.href,
      caption: item.label,
      variant: getButtonVariant(item),
      color: getButtonColor(item),
      tealiumEvent: {
        data_element_id: "MainNav_OEE_Open"
      }
    }
  )))));
};
export {
  SiteNav,
  SiteNav as default
};
//# sourceMappingURL=SiteNav.js.map
